<template>
  <div>
    <leftSideBar :anchor="anchor"></leftSideBar>
    <SideBar></SideBar>
    <div class="secure-block">
      <h3 class="rescue-bigtitle"
          style="margin-bottom:40px;"
          id="one">先进医疗</h3>
      <!-- <p class="secure-note">在日本、欧洲、美国等发达国家，不仅拥有先进的医疗水平和完善的医疗体系，医疗研发能力也处于世界前沿。通过研发靶向药、免疫药物、质子线、重离子线、再生医疗等先进医疗技术，为患者提供更多的治疗选择以及更有效的治疗方法。</p> -->
      <h4 class="rescue-title">质子治疗</h4>
      <p class="secure-note">癌症的治疗手段主要包括手术、放疗和化疗，质子线治疗是放疗的一种。质子线治疗是将氢原子（质子）加速提高能量，针对肿瘤病灶进行定点高能照射。与传统的光子线（X线、γ线等）放疗相比，可减少对其他正常细胞的损伤，对患者身体造成的负担更小，治疗后能保持较高的生活质量。</p>
      <div class="advance-x"
           style="margin-top:41px;">
        <div>
          <img :src="advance1"
               alt="">
          <p class="content_class">传统的X线等放射线治疗，在体表附近释放出最强能量，进入人体后逐渐衰弱。X射线穿过病灶后，心脏或肺部等器官和组织也会受到照射，造成损伤。</p>
        </div>
        <div>
          <img :src="advance2"
               alt="">
          <p>质子线治疗可以根据病灶深度设定质子线照射，在质子射束达到病灶时释放最大的能量后停止，不会穿透到病灶后方，减少对正常组织的损伤。</p>
        </div>
      </div>
      <p class="secure-smalltitle">质子线治疗优势</p>
      <ul class="advance-list">
        <li>
          <span class="span">优势1</span>
          <span class="p">相比于传统放疗，对癌细胞杀伤力更强。</span>
        </li>
        <li>
          <span class="span">优势2</span>
          <span class="p" style="line-height:32px;width: 369px;">降低儿童和年轻患者放疗后的第二原发癌的发生。</span>
        </li>
        <li>
          <span class="span">优势3</span>
          <span class="p">副作用小，对身体负担小。</span>
        </li>
        <li>
          <span class="span">优势4</span>
          <span class="p">无需住院，门诊治疗。</span>
        </li>
      </ul>
      <p class="secure-smalltitle"
         style="margin-top:20px;">质子线适用疾病</p>
      <div class="secure-reason">
        <img :src="advance4"
             style="margin-bottom:60px"
             alt="">
      </div>
      <h4 class="rescue-title"
          id="two">重离子治疗</h4>
      <p class="secure-note"
         style="margin-bottom:39px;">重离子治疗和质子一样，也是放射治疗的一种。但相较于传统的光子线放疗（X线、γ线等）以及质子线治疗，重离子对肿瘤的杀伤力更大，能够将剂量更集中到靶标，减小对肿瘤周围健康组织的损害，尤其是针对一些对放射线不敏感的肿瘤，比如肉瘤、软骨肉瘤、腺癌、黑色素瘤等，治疗十分有效。</p>
      <div class="secure-reason">
        <div><img :src="advance5"
               style="width:414px;"
               alt=""></div>
        <div><img :src="advance6"
               style="width:494px;"
               alt=""></div>
      </div>
      <p class="secure-smalltitle">重离子治疗优势</p>
      <ul class="advance-list">
        <li>
          <span class="span">优势1</span>
          <span class="p"
                style="line-height:32px; width: 369px;">生物作用大。对癌细胞的致死作用是以往X线和质子的2-3倍。</span>
        </li>
        <li>
          <span class="span">优势2</span>
          <span class="p" style="line-height:32px; width: 369px;">照射剂量集中到靶标，减少对健康组织的损害。</span>
        </li>
        <li>
          <span class="span">优势3</span>
          <span class="p">不良反应较少，对身体负担小。</span>
        </li>
        <li>
          <span class="span">优势4</span>
          <span class="p">治疗周期短，通常治疗需1-4周。</span>
        </li>
        <li>
          <span class="span">优势5</span>
          <span class="p" style="line-height:32px; width: 369px;">对一些普通放疗不敏感的癌症的治疗效果好。</span>
        </li>
        <li>
          <span class="span">优势6</span>
          <span class="p">门诊治疗，无需住院。</span>
        </li>
      </ul>
      <p class="secure-smalltitle">重离子线适用疾病</p>
      <div class="independent">
        <!-- <img :src="advance9"  alt=""> -->
        <img :src="advance7_2"
             style="margin-bottom:100px;"
             alt="">
        <!-- <p>◎患者是否适合进行重离子治疗，需咨询专业医师。</p> -->
      </div>
      <h4 class="rescue-title"
          id="three">再生医疗</h4>
      <p class="secure-smalltitle"
         style="margin-bottom:18px;">主要治疗疾病</p>
      <p class="secure-note"
         style="margin-bottom:39px;">再生医疗一般指从患者自身的脂肪中提取干细胞进行分离培养并移植到患病部位，实现人体组织或脏器再生并恢复功能。</p>
      <!-- <p class="secure-smalltitle">主要治疗疾病</p> -->
      <div class="independent">
        <img :src="advance8"
             style="margin-bottom:100px;"
             alt="">
      </div>
      <!-- <p class="secure-smalltitle">治疗流程</p>
            <ul class="red-list">
                <li>
                    <span>咨询</span>
                    <div>
                        <p>提交资料，由医师判断是否适合治疗。同意接收后，预约检查时间。</p>
                    </div>
                </li>
                <li>
                    <span>赴日检查</span>
                    <div>
                        <p>接受血液、影像等适合性检查。检查结果没有问题后，预约治疗时间。</p>
                    </div>
                </li>
                <li>
                    <span>治疗</span>
                    <div>
                        <p>采取脂肪：约1小时，采取5~10g脂肪。1周后拆线。</p>
                        <p>干细胞培养：在专门的细胞培养加工设施（CPC）中分离培养，约4~6周。</p>
                        <p>干细胞的回输：</p>
                        <p>脑梗塞、脊髓损伤:静脉注射1小时</p>
                        <p>变形性膝关节症:局部注射约10分钟</p>
                    </div>
                </li>
                <li>
                    <span>后续</span>
                    <div>
                        <p>针对脑梗塞和脊髓损伤的后遗症，回输后进行2周康复训练。</p>
                        <p>干细胞回输后，进行为期一年的效果评价追踪。</p>
                    </div>
                </li>
            </ul> -->
      <h4 class="rescue-title" id="four">基因治疗</h4>
      <p class="secure-smalltitle"
         style="margin-bottom:18px;">先天性基因疾病</p>
      <p class="secure-note content_class">意大利圣拉斐尔特里松基因疗法研究所（San Raffaele Telethon Institute for Gene
        Therapy，简称SR-Tiget）成立于1995年，一直致力于基因和细胞治疗前沿领域的基础和临床研究，以开发遗传疾病的新治疗方案。</p>
      <p class="secure-note content_class">SR-Tiget虽然较少出现在大众眼前，但是该研究所在基因疗法等领域底蕴深厚。2016年5月，SR-Tiget研发出Strimvelis——用于ADA-SCID（一种严重的免疫缺陷疾病）的基因疗法，并与葛兰素史克公司（GSK）结成战略联盟，将其推向市场。Strimvelis是全球首个被批准上市用于儿童缺陷基因修复的疗法，是基因治疗走向市场的里程碑事件。ADA-SCID治疗获得的成功将HSC基因治疗方法扩展到其他疾病的治疗，尤其是针对WAS综合征和异染性白质脑病。2018年，该研究所开展了针对粘多糖贮积症I型 （Mucopolysaccharidosis type I)（一种先天性风湿病）的临床研究。</p>
      <p class="secure-smalltitle"
         style="margin-bottom:18px;">从基因研究走向基因治疗</p>
      <ul class="list-genius"
          style="margin-bottom:100px;">
        <li>
          <h5>先天性免疫疾病</h5>
          <ul>
            <li>免疫缺陷性疾病</li>
            <li>自身免疫性疾病</li>
            <li>腺苷脱氨酶缺乏型严重联合免疫缺陷（ADA-SCID），又称气泡婴儿病</li>
          </ul>
        </li>
        <li>
          <h5>血液系统疾病</h5>
          <ul>
            <li>贫血、血小板减少、中性粒细胞减少</li>
            <li>输血依赖性β-地中海贫血（TDBT）</li>
            <li>湿疹血小板减少伴免疫缺陷综合征（WAS）</li>
          </ul>
        </li>
        <li>
          <h5>神经退行性代谢紊乱</h5>
          <ul>
            <li>MPSI婴儿游走性部分性癫痫</li>
            <li>异染性白质脑病(MLD症候群)</li>
          </ul>
        </li>
      </ul>
      <h4 class="rescue-title" id="zxlc">咨询流程</h4>
      <div class="independent"
           style="text-align:center;">
        <img :src="advance9"
             style="width:829px;"
             alt="">
      </div>
    </div>
    <div class="main"
         style="width:980px;">

      <h5 class="secure-title title01"
          style="position: relative;z-index: 103;"
          id="five">合作医院
        <router-link to="/hospitalList/xjyl/0"
                     class="ccc"
                     target="_blank">更多 &gt;</router-link>
      </h5>
      <div class="secure-hospital" style="position: relative;z-index: 101;">
        <router-link v-for="(hos, index) in hospitals"
                     :to="'/hospitalInfo/' + hos.id"
                     target="_blank"
                     :key="index">
          <img class="hospital-img"
               :src="baseURL + hos.hospital_img"
               alt="">
          <div class="hospital-content">
            <h6 class="hospital-name"
                v-html="hos.name"></h6>
            <p class="hospital-info">{{hos.easy_brief}}</p>
          </div>
        </router-link>
      </div>
      <h5 class="secure-title title02"
          id="six"
          style="padding-top:70px;position: relative;z-index: 103;">服务案例
        <router-link to="/successCase/6"
                     class="ccc"
                     target="_blank">更多 &gt;</router-link>
      </h5>
      <div class="fw-bg" style="position: relative;z-index: 101;">
        <div class="medicine-case"
             v-for="(c,index) in cases"
             :key="index">
          <router-link target="_blank" :to="{name: 'successCaseDetail',params:{ id: c.id} }">
            <div class="case-info">
              <h5 class="case-info_text">{{c.title}}</h5>
              <p class="case-ill">
                <span>疾病：{{c.disease_name}} </span>
                <span class="b">{{c.alias}}<br/> {{c.age}} 岁</span>
              </p>
              <!-- <p class="case-topic">摘要： {{c.desc}}</p> -->
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import advance1 from "@/assets/images/medicine/advance1.png"
import advance2 from "@/assets/images/medicine/advance2.png"
import advance4 from "@/assets/images/medicine/advance4.png"
import advance5 from "@/assets/images/medicine/advance5.png"
import advance6 from "@/assets/images/medicine/advance6.png"
import advance7 from "@/assets/images/medicine/advance7.png"
import advance7_2 from "@/assets/images/medicine/advance7_2.png"
import advance8 from "@/assets/images/medicine/advance8.png"
import advance9 from "@/assets/images/medicine/advance9.png"
import map from "@/assets/images/home/icon-link1.png"
import leftSideBar from "@/components/LeftSideTitleBar.vue"
import SideBar from "@/components/SideBar"
import * as apis from '@/api/hospital'
import * as cases from '@/api/success'
import { baseURL } from "@/api/axios"
export default {
  data () {
    return {
      baseURL,
      advance1,
      advance2,
      advance4,
      advance5,
      advance6,
      advance7,
      advance7_2,
      advance8,
      advance9,
      map,
      countries: [],
      cases: [],
      hospitals: [],
      anchor: [
        { title: '质子治疗', id: 'one' },
        { title: '重离子治疗', id: 'two' },
        { title: '再生医疗', id: 'three' },
        { title: '基因治疗', id: 'four' },
        { title: '治疗流程', id: 'zxlc' },
        { title: '合作医院', id: 'five' },
        { title: '服务案例', id: 'six' },
      ]
    }
  },
  components: {
    leftSideBar,
    SideBar
  },
  mounted () {
    this.getHospitalList();
    this.getSuccessList();
  },
  methods: {
    async getHospitalList () {
      try {
        let data = {
          hospital_type_id: 6,
          //现金医疗 5
          state_id: undefined,
          area_id: undefined,
          department_id: undefined,
          disease_id: [],
          keyword: undefined,
          page: 1
        }
        let res = await apis.getAllHospitalList(data);
        if (res.code == 200) {
          // console.log(res.data.data)
          let rs = res.data.data.map(item => {
            return {
              ...item,
              info: this.getSimpleText(item.easy_brief)
            }
          });
          if (rs.length > 6) {
            this.hospitals = rs.slice(0, 6);
          } else {
            this.hospitals = rs;
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    getSimpleText (html) {
      var re1 = new RegExp("<.+?>", "g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = html.replace(re1, '');//执行替换成空字符
      return msg;
    },
    async getSuccessList () {
      try {
        let data = {
          page: 1,
          id: 0,
          disease_id: 0,
          type_id: 6
        }
        let res = await cases.getSuccessCaseList(data);
        if (res.code == 200) {
          this.cases = res.data.data.slice(0, 3);
        }
      } catch (e) {
        console.log(e)
      }
    },
    setDoctorName (name) {
      if (name) {
        return name.replace(/\n/g, "<br/>");
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
img {
  backface-visibility:hidden;
  -webkit-backface-visibility:hidden;
}
.ccc:hover {
  color: #2d8cf0!important;
}
.bg-white {
  background: #fff;
  border-top: 1px solid #dcdcdc;
  border-bottom: 1px solid #dcdcdc;
}
.secure-block {
  width: 980px;
  border: 1px solid #dcdcdc;
  background: #fff;
  padding: 30px;
  margin: 20px auto;
}
.secure-title {
  font-size: 24px;
  color: #000;
  // height: 32px;
  line-height: 32px;
  padding-left: 40px;
  // background-repeat: no-repeat;
  // background-position: left center;
  // background-size: 28px auto;
  margin-bottom: 45px;
  a {
    float: right;
    color: #333130;
  }
}
.title01 {
  // background-image: url('../assets/images/home/yy-icon.png');
  padding-top: 107px;
  background: url('../assets/images/home/yy-icon.png') no-repeat 0 107px;
  background-size: 28px 28px;
}
.title02 {
  background: url('../assets/images/home/fwal-icon.png') no-repeat 0 70px;
  background-size: 28px 28px;
}
.secure-reason {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
  div {
    flex: 1;
  }
  img {
    width: 100%;
  }
}
.secure-note {
  font-size: 16px;
  color: #000;
  line-height: 32px;
}

.secure-hospital {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 32px;
  a {
    display: block;
    width: 302px;
    min-height: 396px;
    background: #fff;
    border: 1px solid #dcdcdc;
    margin-bottom: 32px;
    margin-right: 37px;
    &:nth-child(3n + 3) {
      margin-right: 0;
    }
  }
  .hospital-img {
    width: 300px;
    height: 220px;
    margin-bottom: 25px;
  }
  .hospital-name {
    min-height: 47px;
    font-size: 18px;
    color: #333130;
    line-height: 24px;
    margin-bottom: 15px;
    padding: 0 10px;
  }
  .hospital-info {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    color: #9b9898;
    font-size: 16px;
    line-height: 28px;
    padding: 0 10px;
  }
}

.secure-smalltitle {
  font-size: 20px;
  color: #000;
  line-height: 20px;
  border-left: 4px solid #ae1e10;
  padding-left: 9px;
  margin: 40px 0 29px;
  color: #333130;
  font-weight: bold;
}

.advance-x {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
  div {
    width: 440px;
    border: 1px solid #e9ebf4;
    img {
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
      height: 278px;
    }
    p {
      font-size: 16px;
      color: #000;
      line-height: 32px;
      background: #e9ebf4;
      padding: 20px;
      padding-left: 9px;
    }
  }
}
.advance-list {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  li {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 452px;
    min-height: 70px;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 20px;
    background-color: #e9ebf4;
    .span {
      width: 84px;
      height: 100%;
      line-height: 70px;
      background-color: #ae1e10;
      color: #fff;
      text-align: center;
    }
    .p {
      line-height: 70px;
      margin-left: 9px;
    }
  }
}
.independent {
  img {
    width: 100%;
  }
  p {
    text-align: center;
    color: #ccc;
  }
}
.red-list {
  li {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 50px;
    margin-bottom: 20px;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 200px;
      color: #fff;
      font-size: 24px;
      background: #ae1e10;
    }
    div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      flex: 1;
      background: rgb(237, 237, 237);
      padding: 20px 10px;
      p {
        font-size: 16px;
        line-height: 30px;
      }
    }
  }
}
.list-genius {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-around;
  > li {
    width: 300px;
    height: 230px;
    border: 1px solid #e9ebf4;
    h5 {
      height: 50px;
      font-size: 20px;
      color: #333;
      padding-left: 13px;
      background: #e9ebf4;
      line-height: 50px;
    }
    ul {
      padding: 0 15px;
      padding-top: 23px;
    }
    ul li {
      font-size: 15px;
      line-height: 32px;
      list-style: disc;
      list-style-position: inside;
    }
  }
}
.hospital-info {
  -webkit-line-clamp: 2 !important;
}
.content_class {
  text-align: justify;
  -ms-text-align-last: justify;
  -moz-text-align-last: justify;
  text-align-last: start;
  word-break: break-all;
  text-justify: distribute;
}
</style>
